module.exports = __webpack_public_path__ + "static/media/gale-sayers.03d43097.jpg";